import { render, staticRenderFns } from "./SelectClientes.vue?vue&type=template&id=0b71a67a&scoped=true"
import script from "./SelectClientes.vue?vue&type=script&lang=js"
export * from "./SelectClientes.vue?vue&type=script&lang=js"
import style0 from "./SelectClientes.vue?vue&type=style&index=0&id=0b71a67a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b71a67a",
  null
  
)

export default component.exports